import { render, staticRenderFns } from "./ShoppingCarts.vue?vue&type=template&id=50ad1b46&scoped=true"
import script from "./ShoppingCarts.vue?vue&type=script&lang=js"
export * from "./ShoppingCarts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ad1b46",
  null
  
)

export default component.exports